import { FC } from 'react';
import { LogsTableRow } from '../types';
import { DefaultCell } from '@silverfort/sf-components';
import { getDateShortFormat } from '../../../../../utils/dates';

type Props = LogsTableRow;

export const DateCell: FC<Props> = ({ date }) => {
    return <DefaultCell text={getDateShortFormat(date)} />;
};
